import React, { useEffect } from 'react';
import { ArrowLeft, Shield, Lock, Eye, Users, Mail, FileText, Globe, Scale } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const sections = [
    {
      icon: Eye,
      title: "Information We Collect",
      content: "Name, email, phone number, company info, and anything shared via forms.",
      color: "from-blue-500/20 to-turquoise-500/20"
    },
    {
      icon: Users,
      title: "How We Use It",
      content: "To respond to inquiries, schedule consultations, deliver services, and send updates.",
      color: "from-green-500/20 to-turquoise-500/20"
    },
    {
      icon: Shield,
      title: "Sharing",
      content: "We do not sell or rent your personal data. Data may be shared with trusted service providers (payment processors, analytics tools) only as necessary.",
      color: "from-purple-500/20 to-turquoise-500/20"
    },
    {
      icon: Globe,
      title: "Cookies & Tracking",
      content: "We may use cookies to improve site performance and user experience.",
      color: "from-orange-500/20 to-turquoise-500/20"
    },
    {
      icon: Lock,
      title: "Data Security",
      content: "We take reasonable measures to protect your information.",
      color: "from-red-500/20 to-turquoise-500/20"
    },
    {
      icon: FileText,
      title: "Your Rights",
      content: "You can request access, correction, or deletion of your data anytime by contacting shunmugavelsubramanian@gmail.com.",
      color: "from-indigo-500/20 to-turquoise-500/20"
    },
    {
      icon: Scale,
      title: "Governing Law",
      content: "This policy is governed by the laws of India, under the jurisdiction of Tamil Nadu courts.",
      color: "from-pink-500/20 to-turquoise-500/20"
    }
  ];

  return (
    <div className="dark-container min-h-screen" style={{ paddingTop: '100px' }}>
      <div className="max-w-6xl mx-auto px-6 py-12">
        {/* Back Button */}
        <Link to="/">
          <Button className="btn-secondary mb-8">
            <ArrowLeft size={20} />
            Back to Home
          </Button>
        </Link>

        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-6">
            <div className="w-20 h-20 bg-gradient-to-br from-turquoise-500/20 to-blue-500/20 rounded-full flex items-center justify-center border border-turquoise-500/30">
              <Shield size={40} className="text-turquoise-400" />
            </div>
          </div>
          <h1 className="display-large mb-6">
            Privacy <span className="turquoise-text-gradient">Policy</span>
          </h1>
          <p className="body-large text-gray-300 max-w-3xl mx-auto">
            Your privacy is important. Here's how we handle your information with complete transparency and care.
          </p>
        </div>

        {/* Privacy Sections Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {sections.map((section, index) => (
            <div key={index} className={`privacy-card bg-gradient-to-br ${section.color} border border-turquoise-500/20 rounded-16 p-8 hover:border-turquoise-500/40 transition-all duration-300`}>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-turquoise-500/20 rounded-full flex items-center justify-center flex-shrink-0 border border-turquoise-500/30">
                  <section.icon size={24} className="text-turquoise-400" />
                </div>
                <div className="flex-1">
                  <h3 className="heading-3 mb-4 text-white">{section.title}</h3>
                  <p className="body-medium text-gray-300 leading-relaxed">{section.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Updates Notice */}
        <div className="bg-gradient-to-r from-turquoise-500/10 to-blue-500/10 border border-turquoise-500/20 rounded-16 p-8 mb-12">
          <div className="flex items-center gap-4 mb-4">
            <FileText size={24} className="text-turquoise-400" />
            <h3 className="heading-3 text-white">Policy Updates</h3>
          </div>
          <p className="body-medium text-gray-300">
            This policy may change; continued use of the site indicates acceptance of any updates.
          </p>
        </div>

        {/* Contact Section */}
        <div className="text-center bg-gradient-to-br from-gray-900/50 to-turquoise-500/5 border border-turquoise-500/20 rounded-16 p-12">
          <div className="w-16 h-16 bg-turquoise-500/20 rounded-full flex items-center justify-center mx-auto mb-6 border border-turquoise-500/30">
            <Mail size={32} className="text-turquoise-400" />
          </div>
          <h3 className="heading-2 mb-4 text-white">Questions About Privacy?</h3>
          <p className="body-large text-gray-300 mb-6">
            We're here to help with any privacy concerns or data requests.
          </p>
          <Button 
            className="btn-primary-enhanced"
            onClick={() => window.open('mailto:shunmugavelsubramanian@gmail.com', '_blank')}
          >
            <Mail size={20} />
            Contact Us
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;